export const DEFAULT_BACKGROUND_COLOR = '#ffffff00';
export const DEFAULT_PADDING = 0;
export const DEFAULT_BORDER = {
  borderColor: '#343a40',
  borderWidth: 0,
  borderStyle: 'solid'
};
export const DEFAULT_BORDER_RADIUS = {
  topLeft: 0,
  topRight: 0,
  bottomLeft: 0,
  bottomRight: 0,
  measureUnit: '1px' as const
};
